import render from './render'

export default {
  name: 'Panel',

  props: {
    value: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },

  render
}
